import React from 'react';

import Grid from '@mui/material/Grid2';

import DandDCharacterUtilities from "@dndUtilities/char_utilities";

import DataUtilities from "@dndUtilities/data_utilities";

import { 
  ModelBase, 
  PlayerObject
} from "@models";
import { 
  CharacterItem, 
  CharacterSpell, 
  PseudoItem, 
  SummonOption2 
} from "@dndModels";

interface Props {
  obj: ModelBase | PlayerObject | CharacterSpell | CharacterItem | PseudoItem | SummonOption2;
  display_variant?: boolean;
}

const data_util = DataUtilities.getInstance();

export default function DisplayObject({
  obj,
  display_variant = false
}: Props) {

  // const data_type = obj instanceof PseudoItem ? "item" : (obj instanceof SummonOption2 ? "summon" : obj.data_type);
  const detail_format = obj instanceof ModelBase || obj instanceof PlayerObject ? obj.detail_format : "";
  
  const detail = data_util.getStringWithReplacements3({ clean_me: detail_format, backup: "", obj });

  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 12
        }}>
        { display_variant && obj instanceof ModelBase ? obj.true_name : (obj instanceof PlayerObject || obj instanceof CharacterItem || obj instanceof CharacterSpell ? obj.use_name : obj.name) }
      </Grid>
      <Grid
        className="small_label gray"
        size={{
          xs: 12
        }}>
        { detail }
      </Grid>
    </Grid>
  );
}
